<template>
	<div
		class="flex flex-col relative min-w-60 max-w-80 h-84 border border-(--primary-brown) overflow-hidden bg-(--card-background)/50 rounded-sm shadow items-center justify-between gap-2 p-5 transition duration-(--default-transition-duration) hover:cursor-pointer hover:scale-101 hover:shadow-lg"
		@click="openURL(props.itemUrl)"
	>
		<div class="flex w-full items-center border">
			<img
				:src="props.imageSrc"
				:alt="props.name"
				class="w-full object-contain"
			>
		</div>
		<div class="flex flex-col min-w-0 w-full h-1/5 gap-2">
			<p class="size-full truncate shrink-0">
				{{ props.name }}
			</p>
		</div>

		<div
			v-if="itemNeeded"
			class="flex flex-col w-full h-1/5 gap-2 text-ellipsis"
		>
			<span class="flex w-full">${{ props.price }}</span>
			<span class="flex w-full">Need {{ props.quantityNeeded }} of {{ props.quantityRequested }}</span>
		</div>
		<div
			v-else-if="!itemNeeded"
			class="flex w-full h-1/5"
		>
			<span class="flex w-full">No More Needed!</span>
		</div>
	</div>
</template>

<script setup lang="ts">
	import type {
		IWishListItem
	} from "~/types/supabase";

	const props = defineProps<IWishListItem>();
	const itemNeeded = ref<boolean>( props.quantityNeeded > 0 );
	const { openURL } = useUtils();
</script>

<style scoped>

</style>